import React, { Fragment, useState } from 'react';
import { Button, SvgIcon, Tooltip } from '@mui/material';
import DollarIMacIcon from '../../../../icons/dollar-imac.svg?react';
import HealthNotesIcon from '../../../../icons/health-notes.svg?react';
import HealthClassCalc from './HealthClassCalc';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import './HealthClassCalcStackedButton.scss';

export default function HealthClassCalcStackedButton(props) {

  const title = props.title || "NEEDS ANALYSIS";
  const toolName = props.toolName;

  const [modalHealthCalcIsOpen, setModalHealthCalcIsOpen] = useState(false);

  const modalNeedsCalculatorFields = {
    modalHealthCalcIsOpen: modalHealthCalcIsOpen,
    setModalHealthCalcIsOpen: setModalHealthCalcIsOpen,
  };

  const handleToolTip = (e) => {
    e.stopPropagation();
  };

  return (
    <Fragment>
      {props.condensed ?
        <div className="health-rating-basic-button">
          <Button type="button"
            onClick={() => setModalHealthCalcIsOpen(true)}
            variant={props.isPrequote ? undefined : "contained"}
            color="primary"
            className={`quote-health-button button-white`}>
            {props.toolName}
            <span className="help-container" onClick={handleToolTip}>
              <Tooltip
                title={props.title}
                enterTouchDelay={0}
                slotProps={{
                  tooltip: {
                    className: 'light-tooltip',
                    sx: { fontSize: '11px' }
                  },
                }}
              >
                <InfoOutlinedIcon className='help-tooltip' fontSize="small" />
              </Tooltip>
            </span>
          </Button>
        </div>
        :
        <div className="health-rating-stacked-button">
          <Button type="submit"
            onClick={() => setModalHealthCalcIsOpen(true)}
            variant={props.isPrequote ? undefined : "contained"}
            color="primary"
            className={`quote-health-button button-white`}
          >
            {props.isPrequote ? <SvgIcon component={HealthNotesIcon} color="primary" /> : <div className="icon-container mb-0 background-color-16"><SvgIcon component={DollarIMacIcon} color="primary" /></div>}
            <h3 className="tool-name">{toolName}</h3>
            <span className="name">&nbsp;{title}</span>
          </Button>
        </div>
      }
      <HealthClassCalc fields={modalNeedsCalculatorFields} isPrequote={props.isPrequote} currentHealthClass={props.currentHealthClass} onHealthClassChange={props.onHealthClassChange} />
    </Fragment>
  );
}
